import type { FaireProductEntity } from "../../entity_types/product";

export const p_wg8njj3mcs: FaireProductEntity = {
  token: "p_wg8njj3mcs",
  type: "product",
  name: "Unpackaged High Protein Deep Conditioning Bar",
  brandToken: "b_bruvtyx6ew",
  brandName: "Simpl Bars",
  imageUrl:
    "https://cdn.faire.com/fastly/5c3cb8bb9b915d5e6680fae43915b558820913c730d7c4e1180bd82dac19a158.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe129793da2512edfbeac35d0fc3325e05c22df30719153630a918761c6f557f.jpeg",
    "https://cdn.faire.com/fastly/54225f65dd6f749362b900eeb87a519924cd700e0096d9dea47151bd908966fa.jpeg",
    "https://cdn.faire.com/fastly/557abe4372e95a39effcc79ed6e19bcd3e1559d257d396a07f5052e436ba7e7a.jpeg",
  ],
  priceDollars: 7,
  description:
    "Unpackaged version of our Cacao & Protein Deep Conditioning Treatment in 2oz and 3oz size. Perfect for refilleries/zero waste or bulk stores. \n\nThis deep nourishing and repairing treatment features three different kinds of proteins to restore your strands. Hemp protein smoothens, rice protein increases elasticity and quinoa gives it a gorgeous shine. We combine cocoa butter, shea butter and avocado oil for an extra boost of vitamins and hydration.\n\nFor best results, wash hair with your favorite Simpl Bars shampoo bar, apply the conditioning treatment, leave on for 10+ minutes and then rinse. \n\nIf you're a busy mama like we are, try this with dirty hair a little bit before your shower: You can get your hair ends wet, apply the product, leave it on for 10+ minutes and then wash your hair with your shampoo and conditioner bars as normal. \n\nColor safe\nGluten Free\nVegan",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:01.590Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
